module.exports = __webpack_public_path__ + "img/fridge.61d72940.svg";